import React from 'react';
import Layout from '../layout';
import TestSectionOne from '../components/Esper/Test/TestSectionOne';
import TestSectionTwo from '../components/Esper/Test/TestSectionTwo';
import TestSectionThree from '../components/Esper/Test/TestSectionThree';
import TestSectionFour from '../components/Esper/Test/TestSectionFour';
import TestSectionFive from '../components/Esper/Test/TestSectionFive';
import TestOgImage from '../assets/v2/png/Testhero.png';
import messages from '../i18n/en';

class Retail extends React.Component<any, any> {
  public render() {
    return (
      <Layout
        ogImage={TestOgImage}
        location={this.props.location}
        messages={messages}
        title={'Test android applications on real devices | Esper'}
        description={`Use adb to test applications on real devices using Esper. Also create custom device emulators and check device and app behaviour`}
        keywords={`adb,test application,android emulator,adb android`}
      >
        <TestSectionOne />
        <TestSectionTwo />
        <TestSectionThree />
        <TestSectionFour />
        <TestSectionFive />
      </Layout>
    );
  }
}
export default Retail;
